import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderContainer, PlaceholderImageElement, IconWrapper, } from "./Avatar.style";
import { typography } from "../../../base/styled/typography.style";
import { buildImageUrl } from "../../../utils/buildImageUrl";
const PlaceholderImage = ({ aspectRatio = "1:1", width, height, className, imageUrl, shape, altText = "Imagem de placeholder", }) => {
    const hasAspectRatioTrick = height === undefined && aspectRatio !== undefined;
    // Use a valid image URL string as fallback, not the component itself
    const finalImageUrl = imageUrl || ""; // or provide a default placeholder image URL here
    return (_jsx(PlaceholderContainer, { "$aspectRatio": aspectRatio, "$width": width, "$height": height, "$shape": shape, className: className, children: _jsx(IconWrapper, { "$hasAspectRatioTrick": hasAspectRatioTrick, children: finalImageUrl ? (_jsx("button", { type: "button", style: {
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, "aria-label": altText, children: _jsx(PlaceholderImageElement, { src: buildImageUrl(finalImageUrl, { wid: width, hig: height }), alt: altText, "$hasAspectRatioTrick": hasAspectRatioTrick }) })) : ((() => {
                const getInitials = (text) => {
                    var _a;
                    if (!text)
                        return "";
                    const words = text.trim().split(" ");
                    if (words.length === 1)
                        return ((_a = words[0][0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "";
                    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
                };
                const initials = getInitials(altText);
                return (_jsx("button", { type: "button", style: {
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }, "aria-label": altText, children: _jsx("span", { style: width === 24 && height === 24
                            ? {
                                fontSize: "14px",
                                lineHeight: "20px",
                                marginTop: "3px",
                            }
                            : width === 64 && height === 64
                                ? { fontSize: "18px" }
                                : typography.linkLarge, children: initials || "Imagem não disponível" }) }));
            })()) }) }));
};
export default PlaceholderImage;
//# sourceMappingURL=Avatar.js.map